<template>
    <div>
        <label class="switch m-0">
            <input 
                type="checkbox" 
                v-model="checked">
            <span class="slider round"></span>
        </label>
    </div>
</template>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: -2px;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #00b427;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00b427;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>

<script>
import BootstrapToggle from "vue-bootstrap-toggle";

export default {
    props: [ "salepage", "shop" ],
    components: { BootstrapToggle },
    data() {
        return {
          checked: this.salepage?.status_active == 1 ? true
            : this.salepage?.status_active == 0 ? false
            : false
        };
    },
    watch: {
        checked(val) {
            this.toggle();
        }
    },
    methods: {
        toggle() {
            axios
              .patch(`/backend/s/${this.shop}/salepages/${this.salepage.id}/update-is-action`, {
                status_active: this.checked
              })
              .then((res) => {

              })
              .catch((err) => {

              });
        }
    }
};
</script>
